import { withStyles } from '@material-ui/core/styles';
import MuiTypography, {
  TypographyProps as MuiTypographyProps,
} from '@material-ui/core/Typography';

const Typography = withStyles<'root', {}, MuiTypographyProps>(
  (theme) => ({
    root: {
      '& strong': { fontWeight: theme.typography.fontWeightBold },
    },
  }),
  { name: 'FdTypography' },
)(MuiTypography);

export default Typography;
